"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemitoConverter = void 0;
const RemitoConverter = {
    toFirestore(remito) {
        return remito;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            version: data.version,
            id: data.id,
            fechaComprobante: data.fechaComprobante,
            fechaCreacion: data.fechaCreacion,
            comprobante: data.comprobante,
            localIngresa: data.localIngresa,
            localSale: data.localSale,
            entidadId: data.entidadId,
            entidadNombre: data.entidadNombre,
            items: data.items,
            observaciones: data.observaciones,
            tipo: data.tipo,
            autor: data.autor,
            activo: data.activo,
            cfeId: data.cfeId,
            esDeExportacion: data.esDeExportacion,
            clausulaVenta: data.clausulaVenta,
            modalidadVenta: data.modalidadVenta,
            viaTransporte: data.viaTransporte,
            facturado: data.facturado,
            cfeNumero: data.cfeNumero,
            cfeSerie: data.cfeSerie,
            cfeTipo: data.cfeTipo,
            cfeMotivoRechazoDGI: data.cfeMotivoRechazoDGI,
            cfeMotivoRechadoReceptor: data.cfeMotivoRechadoReceptor,
            cfeEstadoDGI: data.cfeEstadoDGI,
            cfeEstadoReceptor: data.cfeEstadoReceptor,
            remitoCanceladoId: data.remitoCanceladoId ?? "",
            remitoCanceladoComprobante: data.remitoCanceladoComprobante ?? "",
            remitoCancelanteId: data.remitoCancelanteId ?? "",
            remitoCancelanteComprobante: data.remitoCancelanteComprobante ?? "",
            esContingencia: data.esContingencia ?? false
        };
    }
};
exports.RemitoConverter = RemitoConverter;
